export default {
  reassuranceTitle: {
    id: 'product_page_reassurance_title',
    defaultMessage: 'Only at Back Market',
  },
  delivery: {
    id: 'product_page_delivery',
    defaultMessage: 'delivery',
  },
  discount: {
    id: 'product_reassurance_discount',
    defaultMessage: '{discount} discount vs new',
  },
  deliveryWithDate: {
    id: 'product_page_shipping_with_date',
    defaultMessage: 'Get it between {dates, html} free standard shipping',
  },
  deliveryDates: {
    id: 'product_page_shipping_dates',
    defaultMessage: '{earliest} and {latest}',
  },
  expressDelivery: {
    id: 'product_page_express_shipping',
    defaultMessage: 'Get it from {amount} between {earliest} and {latest}',
  },
}
